import React  from 'react';
import Select from 'react-select'
import {API_URL} from '../../../constants';
import {GenerateArrayToDropDown} from '../../../functions';
import {filterOptions} from '../../../functions';
import {approveRole} from '../../../functions';
import {toast} from 'react-toastify';
import axios from 'axios';

const urlBase  = `${API_URL}`

function UpdateStateMaster(type, key, keyChild)
{
    if (keyChild===undefined) keyChild=0;

    switch(type)
    {
                case 'Categoria':
                if(key==null || key.length==0){
                    this.setState({
                        value: [{
                            value: 0,
                            label: "Seleccione Sector",
                        }]
                    });

                    return;  // There is no key
                }
                // Set format to sector's keys when values are int

                return new Promise(resolve => {
                    axios.get(urlBase + 'CategoryUX/' + key.value).then(response => response.data)
                    .then((data) => {

                        // console.log('UpdateStateMaster 1', data);
                        var itemSelected = {};
                        var option = GenerateArrayToDropDown(data.result.map(option => { return {value: option.crec_Id, label: option.crec_Nombre}}));

                        // console.log('UpdateStateMaster 2 ', option);

                        option.map((item, i)=> { if (item.value.toString() === keyChild.toString()) itemSelected=item; });
                        // console.log('UpdateStateMaster 3 ', itemSelected);

                        this.setState({
                            optionsChild : option, 
                            value: { value: itemSelected.value, label: itemSelected.label }
                        });
                    })
                    .catch(error => {
                        console.log("ERROR Categoria", error);
                    });
                });
                break;

        default:
            break;
    }

};


class DropDownListMaster extends React.Component {

    constructor(props)
    {
        super(props);
        this.state = {
            value: [],
            id:'',
            name:'',
            componente : '',
            clave: '',
            values: [],
            readOnly: false,
            options:[],
            optionsChild: [],
            isMulti : this.props.isMulti,
        }
    }

    updateChildMaster(child, key) {
        UpdateStateMaster(child, key)
    }

    handleChangeMaster(item, id, child){  // Handle change in Select component
        // Prevent placeholder to be added
        if(item && item.length>0 && item[item.length-1].value==0) return;

        if(typeof this.props.onChange === 'function'){
            // Store item as an object 'cuz it'll handle more than one value
            var event = {target: { name: id, value: item, type: 'dropdow' }};
            this.props.onChange(event);
        }

        this.setState({value: item}, ()=> 
        {
            this.updateChildMaster(child, item);
        } );
    }

    componentWillMount(){
        this.LoadResourcesType(this.props.componente);
    }

 
    LoadResourcesType(type){
        // console.log('LoadResourcesType',type)

        switch(type)
        {
            
            case 'TipoRecurso':
                return new Promise(resolve => {
                    axios.get(urlBase + 'ResourceTypeUX/').then(response => response.data)
                    .then((data) => {

                        var itemSelected = {};
                        this.options = GenerateArrayToDropDown(data.result.map(option => { return {value: option.nTipoRecursoCodigo, label: option.sDescripcion} }));

                        this.options.filter((item)=> { if (item.value === this.props.clave) itemSelected=item; });

                        this.setState(
                            { options:this.options }, 
                                ()=> { this.setState(
                                                        { value: { value: itemSelected.value, label: itemSelected.label }
                                                        },
                                                        ()=> {   UpdateStateMaster("Categoria", itemSelected, this.props.valorHijo); 
                                                            // console.log('UpdateStateMaster'); 
                                                        }
                                                    )
                                    }
                                    );
                         
                    })
                    .catch(error => {
                        toast.error("¡Error al cargar recursos! :[Tipo de Recursos]");
                    });
                });
                break;
        }

    }

    render() {
        return (
        (this.props.metodo==="add" && !this.state.value)?(
            <Select
                classNamePrefix="select"
                placeholder="Seleccione una opción de la lista"
                id = {this.props.id}
                name = {this.props.name}
                options={this.state.options}
                onChange={value => this.handleChangeMaster(value, this.props.id, this.props.child)}
                isSearchable={true}
                isMulti={this.state.isMulti}
            />):
        (
            <Select
            classNamePrefix="select"
            placeholder="Seleccione una opción de la lista"
            id = {this.props.id}
            name = {this.props.name}
            options={this.state.options}
            value={this.state.value}
            onChange={value => this.handleChangeMaster(value, this.props.id, this.props.child)}
            isSearchable={true}
            isMulti={this.state.isMulti}
        />
        )
        )
    }
}

class DropDownListChildMaster extends React.Component {

    constructor(props)
    {
        super(props);
        this.state = {
            value: { label: this.props.val, value: this.props.valorPadre },
            id: this.props.id,
            name:'',
            componente : '',
            clave: '',
            values: [],
            readOnly: false,
            parentKey: ((this.props.clavePadre===undefined)?(0):(this.props.clavePadre)),
            optionsChild: [],
        }
        UpdateStateMaster = UpdateStateMaster.bind(this);
    }

    handleChangeChildMaster(item, id) {
        if (typeof this.props.onChange === 'function') {
            var event = {target: { name: id, value: item.value, type: 'dropdow' }};
            this.props.onChange(event);
        }

        // console.log('adsasdasdasdas');
        
        this.setState({value: item});
    }

    render(){

        return (
            <Select
                id = {this.props.id}
                name = {this.props.name}
                options={this.state.optionsChild}
                value={this.state.value}
                onChange={value => this.handleChangeChildMaster(value, this.props.id)}
            />
        )
    }
}

export {DropDownListMaster, DropDownListChildMaster}
